export const GET_TIES = "GET_TIES";
export const GET_TIE_BY_ID = "GET_TIE_BY_ID";
export const UPDATE_TIE = "UPDATE_TIE";
export const DELETE_TIE = "DELETE_TIE";
export const CREATE_TIE = "CREATE_TIE";
